import { useCallback } from 'react';

import { useScanToPayLoyaltyProfile } from '../useScanToPayLoyaltyProfile';
import { useScanToPayCreditBalance } from '../useScanToPayCreditBalance';
import { useScanToPayPaymentMethods } from '../useScanToPayPaymentMethods';
import { useScanToPayIdentifyToken } from '../useScanToPayIdentifyToken';
import { useScanToPayPaymentToken } from '../useScanToPayPaymentToken';
import { useScanToPayDefaultPaymentMethod } from '../useScanToPayDefaultPaymentMethod';
import { useScanToPayMachine } from '../../machine';
import { ScanToPayMachineServices } from '../../machine/scan-to-pay.machine.types';

/**
 * Hook that binds the ordering machine with the external data.
 */
export const useScanToPayState = () => {
  const { fetchLoyaltyProfile } = useScanToPayLoyaltyProfile();
  const { fetchCredits } = useScanToPayCreditBalance();
  const { fetchPaymentMethods } = useScanToPayPaymentMethods();
  const { fetchIdentifyToken } = useScanToPayIdentifyToken();
  const { fetchPaymentToken } = useScanToPayPaymentToken();
  const { setDefaultPaymentMethod } = useScanToPayDefaultPaymentMethod();

  const fetchData = useCallback(async (): Promise<
    ScanToPayMachineServices['fetchData']['data']
  > => {
    const [
      { availablePoints, pointsRewards },
      { availableCredit },
      { paymentMethods },
    ] = await Promise.all([
      fetchLoyaltyProfile(),
      fetchCredits(),
      fetchPaymentMethods(),
    ]);

    return {
      availablePoints,
      availableCredit,
      pointsRewards,
      paymentMethods,
    };
  }, [fetchLoyaltyProfile, fetchCredits, fetchPaymentMethods]);

  return useScanToPayMachine({
    fetchData,
    fetchIdentifyToken,
    fetchPaymentToken,
    setDefaultPaymentMethod,
  });
};
